import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tree, Col, Row, Card, Breadcrumb, Button, Message } from 'antd';
import PageHeaderLayout from '../../layouts/PageHeaderLayout';
import { Global } from '../../models';
import styles from './style.less';

const { TreeNode } = Tree;

const recursive = (array) => {
  let returnArray = [];

  array.forEach((entry) => {
    if (entry.checked) {
      returnArray.push(entry.id.toString());
    }
    if (entry.districts && entry.districts.length) {
      returnArray = [...recursive(entry.districts), ...returnArray];
    }
  });
  return returnArray;
};

class DistrictContainer extends Component {
  static propTypes = {
    global: PropTypes.object.isRequired,
    getDistricts: PropTypes.func.isRequired,
    updateDistricts: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      checked: [],
    };
  }

  componentDidMount = () => {
    this.refresh();
  }

  onCheck = (checked) => {
    this.setState({
      checked,
    });
  }

  refresh = async () => {
    await this.props.getDistricts();
    this.setState({
      checked: recursive(this.props.global.districts),
    }, () => {
      console.log(this.state.checked);
    });
  }

  handleUpdate = async () => {
    await this.props.updateDistricts(this.state.checked || []);
    if (this.props.global.error) {
      Message.error('Хүргэлт хийх дүүрэг, хороог хадгалах амжилтгүй');
    } else {
      Message.success('Хүргэлт хийх дүүрэг хороог амжилттай хадгаллаа');
      await this.refresh();
    }
  }

  renderTreeNodes = data => data.map((item) => {
    if (item.districts) {
      return (
        <TreeNode title={item.name} key={item.id} selectable={false} dataRef={item}>
          {this.renderTreeNodes(item.districts)}
        </TreeNode>
      );
    }
    return <TreeNode key={item.id} selectable={false} title={item.name} dataRef={item} />;
  })

  render() {
    const breadcrumb = (
      <Col span={24}>
        <div className={styles.pageTop}>
          <Col span={12}>
            <Breadcrumb className={styles.Topbread}>
              <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
              <Breadcrumb.Item>Хүргэлт хийх дүүргүүд</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={12} style={{ marginTop: 3 }}>
            <div className={styles.TopGuide}>
              <ul className={styles.orderGuide}>
                <li> Хүргэлт хийх дүүрэг, хороо: <strong>{this.state.checked.length}</strong></li>
              </ul>
              <div className={styles.topBtn}>
                <Button onClick={this.handleUpdate} icon="inbox" type="primary" size="small" style={{ fontSize: 13 }}>Сонголтыг хадгалах</Button>
              </div>
            </div>
          </Col>
        </div>
      </Col>
    );


    return (
      <PageHeaderLayout
        style={{ padding: '0' }}
        top
        content={breadcrumb}
      >
        <Card bordered loading={this.props.global.isLoading}>
          <Row type="flex" justify="start">
            <Col span={24}>
              <Col span={12}>
                <span className={styles.pageHeading}>Хүргэлт хийх дүүргүүд</span>
              </Col>
            </Col>
          </Row>
          <Row type="flex" justify="start">
            <Col span={24}>
              <div>
                <Tree
                  checkable
                  multiple
                  showLine
                  autoExpandParent
                  defaultCheckedKeys={this.state.checked || []}
                  defaultExpandedKeys={this.state.checked}
                  defaultExpandParent
                  checkedKeys={this.state.checked || []}
                  onCheck={this.onCheck}
                  className={styles.customTree}
                >
                  {this.renderTreeNodes(this.props.global.districts || [])}
                </Tree>
              </div>
            </Col>
            <Col span={12} />
          </Row>
        </Card>
      </PageHeaderLayout>
    );
  }
}

const mapStateToProps = state => ({
  global: state.global,
});

const mapDispatchToProps = ({
  getDistricts: Global.loadDistrict,
  updateDistricts: Global.updateDistrict,
});

export default connect(mapStateToProps, mapDispatchToProps)(DistrictContainer);



// WEBPACK FOOTER //
// ./src/containers/District/index.js